import PropTypes from "prop-types";

const AnimatedBlock = ({ className }) => (
  <div className={`bg-primary animate-pulse rounded ${className}`} />
);

AnimatedBlock.propType = {
  className: PropTypes.string.isRequired,
};
export default AnimatedBlock;
